//Calculations of the hours, days and dates
//Initialize all the variables needed for the calculations
const day = new Date().getDate()
const month = new Date().getMonth()
const year = new Date().getFullYear()
const hour = new Date()
	.getHours()
	.toLocaleString("ro-RO", { timeZone: "Europe/Bucharest" }) //always romanian time
const hours = Array(24)
	.fill()
	.map((e, i) => i) //all hours in a day

//Find available hours during regular day (between 10 and 19)
const allHours = hours.slice(
	hours.findIndex((h) => h == 10),
	hours.findIndex((h) => h == 19)
)

//Find available hours left today (between 10 and 19)
const todayHours = hours.slice(
	hours.findIndex((h) => hour >= 8 ? h == +hour + 1 : h == 10),
	hours.findIndex((h) => h == 19)
)

//if today has no available spot, the available hours will get the value of all intervals during the day, and today won't be displayed in the calendar
const availableHours = todayHours.length != 0 ? [...todayHours] : [...allHours]

//Find the next 14 days and specify which one is during weekend (unavailable)
const getAllDaysInTwoWeeks = (day, month, year, todayHours) => {
	const createArray = (length) => [...Array(length)] //creates an array of a specific length
	const options = {
		day: "numeric",
		weekday: "long",
		month: "long",
		year: "numeric",
	}

	const dates = createArray(14)
		.map((element, index) => new Date(year, month, day + index)) //populate empty array with following dates
		.map((entry) => {
			return `${entry.toLocaleDateString(
				"ro-Ro",
				options
			)}`
		}) //fixed format, csf (Sunday has an additional "weekend" in the string)

	if (todayHours.length == 0) dates.shift() //remove first day if no hours available
	return dates
}

//Check the first available day in order to be selected automatically in the calendar
const checkFirstAvailableDay = (days) => {
	const isNotWeekend = (element) => !element.includes("weekend")
	return days.findIndex(isNotWeekend)
}

const nextDaysAvailable = getAllDaysInTwoWeeks(day, month, year, todayHours) //get the array of days
const nextDayAvailable = checkFirstAvailableDay(nextDaysAvailable) //get the index of the first available day (today, tomorrow, monday)

export { allHours, availableHours, nextDaysAvailable, nextDayAvailable }
